var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"draggable":_vm.editEnabled,"id":_vm.task.id}},[_c('state-button',{attrs:{"small":true,"state":_vm.buttonState},on:{"click":_vm.onAddAppointment}},[_vm._v(" "+_vm._s(_vm.$t("scheduling.taskDetails.addAppointment"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }